import Vue from 'vue'
import App from './App.vue'
import Cookies from "js-cookie";
import router from './router'
import store from './store'
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts';
import "echarts-wordcloud";
import axios from "axios";
const utile = require("./utile.js");
import instance from './utils/Http'
// import size from './size'
import {Message} from 'element-ui'
import JsonExcel from 'vue-json-excel'
import OperationLog from "./utils/OperationLog.js";
Vue.component('downloadExcel', JsonExcel)

import "vant/lib/index.css";
import { DatetimePicker  } from "vant";
import '@vant/touch-emulator';
// 新增
import "./assets/fonts/iconfont.css";
import "./assets/fonts/iconfont.js";
Vue.use(DatetimePicker);

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = instance;
Vue.prototype.$utile = utile;
Vue.prototype.$operationLog = OperationLog

import "@/assets/style/bootstrap.css";
import mixin from './mixins';

Vue.mixin(mixin);
let Messagee = function(msg) {
  return Message({
    message:msg,
    duration:1200
  })
}
Messagee.error = function (msg) {
  return Message.error({
    message: msg,
    duration: 1200,
    customClass: "customClass",
  })
}
Messagee.success = function (msg) {
  return Message.success({
    message: msg,
    duration: 1200,
    customClass: "customClass",
  })
}
Messagee.warning = function (msg) {
  return Message.warning({
    message: msg,
    duration: 1200,
    customClass: "customClass",
  })
}
Vue.prototype.$messagee = Messagee;
ElementUI.Dialog.props.lockScroll.default = false;

Vue.use(ElementUI)
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
}).$mount('#app')



